/**
 * The external dependencies.
 */
import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
import {compose, find, pluck, propEq, zipObj} from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../../components/general/flex-root';
import Header from '../../../components/task/shop/header';
import Text from '../../../components/task/shop/text';
import Steps from '../../../components/task/shop/form/steps';
import Actions from '../../../components/task/shop/form/actions';
import QuantityInput from '../../../components/task/shop/form/quantity-input';
import StepsInput from '../../../components/task/shop/form/steps-input';
import WorkplaceInput from '../../../components/task/shop/form/workplace-input';
import {getAuthUser} from '../../../store/auth/selectors';
import {tasksDeselect, tasksUpdate} from '../../../store/tasks/actions';
import {
    getTasksCountForCurrentUsers,
    getTasksCurrent,
    getTaskStepsCount,
    getTaskWorkSteps,
} from '../../../store/tasks/selectors';
import {setOverlay, tasksWorkStarted} from "../../../store/tasks/actions";
import {getWorkstepcount} from "../../../store/tasks/selectors";
import {noworkplace} from "../../../store/auth/selectors";

const Wrapper = styled(FlexRootWrapper)`
	background: #f8f8f8;
	flex-direction: row;
`;

const InputsWrapper = styled(FlexRootWrapper)`
	padding: 26px 16px 26px 21px;
	border-left: 1px solid #e0e1e1;
`;

class Form extends React.Component {
    constructor(props) {
        super(props);
        const {user, noworkplace} = props;
        this.state = {
            currentStep: null,
            isFormCompleted: null,
            inputs: [
                {
                    id: 'quantity',
                    label: 'Stückzahl wählen',
                    current: false,
                    completed: true,
                    value: R.clone(this.props.task.quantity),
                    component: QuantityInput,
                    maxValue: this.props.task.quantity,
                    next: 'none'
                },
                {
                    id: 'step',
                    label: 'Arbeitsschritt wählen',
                    current: null,
                    completed: null,
                    value: 0,
                    component: StepsInput,
                    maxValue: this.props.workstepCount,
                    prev: 'quantity'
                },

            ]
        };

        if (!noworkplace) {
            if (R.isNil(user.workplace) || R.isEmpty(user.workplace)) {
                this.state.inputs.push({
                    id: 'place',
                    label: 'Arbeitsplatz wählen',
                    current: null,
                    completed: null,
                    value: '',
                    valuePrefix: 'Arbeitsplatz',
                    component: WorkplaceInput,
                    prev: 'step'
                })
            } else {
                this.state.inputs.push({
                    id: 'place',
                    label: 'Arbeitsplatz wählen',
                    current: null,
                    completed: true,
                    value: user.workplace,
                    valuePrefix: 'Arbeitsplatz',
                    component: WorkplaceInput,
                    prev: 'step'
                })
            }
        }
    }

    setCurrentStep = (step) => {
        const {inputs} = this.state;
        const currentlyActive = find(propEq('current', true))(inputs);
        const currentlyClicked = find(propEq('label', step.label))(inputs);

        if (currentlyActive) {
            currentlyActive.current = false;
        }

        const shouldSetToCurrent = !(currentlyActive && currentlyClicked.label === currentlyActive.label);

        currentlyClicked.current = shouldSetToCurrent;

        this.setState({
            currentStep: shouldSetToCurrent
                ? currentlyClicked
                : null,
        });
    };

    setStepAsCompleted = (step) => {
        if (!step.value) {
            return;
        }

        const {inputs} = this.state;

        const currentlyClicked = find(propEq('label', step.label))(inputs);

        currentlyClicked.current = false;
        currentlyClicked.completed = true;

        this.setState({
            currentStep: null,
            isFormCompleted: inputs.length === inputs.filter(i => i.completed).length,
        });

        const nextStep = find(propEq('prev', step.id))(this.state.inputs);
        if (nextStep) {
            this.setCurrentStep(nextStep);
        }
    };

    updateStepCurrentValue = (value) => {
        const currentStep = find(propEq('current', true))(this.state.inputs);
        currentStep.value = value;
        this.setState({currentStep});
    };


    getInputsValues() {
        const {inputs} = this.state;

        return zipObj(pluck('id', inputs), pluck('value', inputs));
    }

    reserve = (submit = null) => {
        const {
            task,
            tasksUpdate,
            tasksDeselect,
            user,
            setOverlay
        } = this.props;

        const data = {
            ...this.getInputsValues(),
            // id: `${task.order_id}-chunk-${user.username}-${tasksForUserCount}`,
            id: `${task.id}`,
            status: 'reserved',
            worker: user.fullname,
        };

        setOverlay({task: task, type: 'reserveTask'});
        tasksUpdate(task.id, data, user);
        tasksDeselect();
    };

    submit = () => {
        const {
            task,
            tasksUpdate,
            user,
            tasksWorkStarted,
        } = this.props;

        const data = {
            ...this.getInputsValues(),
            // id: `${task.order_id}-chunk-${user.username}-${tasksForUserCount}`,
            id: `${task.id}`,
            status: 'in-progress',
            worker: user.fullname,
        };

        tasksUpdate(task.id, data, user);
        // tasksWorkStarted(task);
        this.props.history.push('/dashboard/working');
    };

    render() {
        const {
            currentStep,
            isFormCompleted,
            inputs
        } = this.state;

        const InputComponent = currentStep ? currentStep.component : null;

        return (
            <Wrapper>
                <FlexRootWrapper>
                    <Header color="#d9d7d7"></Header>

                    <Steps steps={inputs} handleSelect={this.setCurrentStep}/>

                    <Actions
                        disabled={!isFormCompleted || currentStep !== null}
                        reserve={this.reserve}
                        submit={this.submit}
                    />
                </FlexRootWrapper>

                {currentStep && (
                    <FlexRootWrapper>
                        <Header color="#d9d7d7" textColor="#707070;">
                            <Text flex>
                                {currentStep.label}
                            </Text>
                        </Header>

                        <InputsWrapper>
                            <InputComponent
                                data={currentStep}
                                handleSelect={this.updateStepCurrentValue}
                                handleComplete={this.setStepAsCompleted}
                            />
                        </InputsWrapper>
                    </FlexRootWrapper>
                )}
            </Wrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            workSteps: getTaskWorkSteps(state),
            task: getTasksCurrent(state),
            steps: getTaskStepsCount(state),
            user: getAuthUser(state),
            tasksForUserCount: getTasksCountForCurrentUsers(state),
            workstepCount: getWorkstepcount(state),
            noworkplace: noworkplace(state),
        }), {
            tasksUpdate,
            tasksDeselect,
            setOverlay,
            tasksWorkStarted,
        }
    ),
    withRouter
)(Form);



// WEBPACK FOOTER //
// ./src/containers/task/shop/form.js